module["exports"] = [
  "###",
  "##",
  "#",
  "##a",
  "##b",
  "##c"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/building_number.js
// module id = 986
// module chunks = 1